// extracted by mini-css-extract-plugin
export default {"quick-action":"quickAction_quick-action__wbMAM","quick-actions-item":"quickAction_quick-actions-item__FSFcu"};